export default __webpack_public_path__ + "static/media/wave-signin.9a07100a.png";